import {ChangeDetectionStrategy, Component, Optional} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {BaseComponent} from 'compob2b-libs';

@Component({
    templateUrl: './popup-address.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PopupAddressComponent extends BaseComponent {
  private address = '';
  private latitude = '';
  private longitude = '';

  constructor(@Optional() protected readonly windowRef: NbWindowRef) {
    super();
  }

  onSelect($event: any) {
    this.address = ($event !== null && 'unrestricted_value' in $event) ? $event.unrestricted_value : '';
    this.latitude = $event?.data?.geo_lat;
    this.longitude = $event?.data?.geo_lon;
    this.cdr.detectChanges();
  }

  onSubmit() {
    if (this.selected()) {
      this.windowRef.close({address: this.address, latitude: this.latitude, longitude: this.longitude});
      this.cdr.detectChanges();
    }
  }

  selected() {
    return this.address !== null && this.address.length;
  }

}
